import { lazy } from "react";

const Login = lazy(() => import("../pages/login"));
const Dashboard = lazy(() => import("../pages/dashboard/view"));
const UserProfileUpdate = lazy(() => import("../pages/user-profile/update"));
const ForgotPassword = lazy(() => import("../pages/forgot-password/index"));
const ResetPassword = lazy(() => import("../pages/reset-password/index"));
const CreatePassword = lazy(() => import("../pages/create-password/index"));
const AdminList = lazy(() => import("../pages/user-management/admin/list"));
const AddUser = lazy(() => import("../pages/user-management/admin/add"));
const CMSlist = lazy(() => import("../pages/cms-pages/CMSlist"));
const Blog = lazy(() => import("../pages/blogs/list"));
const AddBlog = lazy(() => import("../pages/blogs/add"));
const RoleList = lazy(() => import("../pages/role-management/list"));
const AddRole = lazy(() => import("../pages/role-management/add"));
const ActivityLogs = lazy(() => import("../pages/activity-logs/list"));

const routes = {
  LOGIN: {
    path: "/login",
    component: Login,
    requireLogin: false,
    allowAccessWhenLoggedIn: false,
    pageTitle: "Login",
  },
  DASHBOARD: {
    path: "/",
    component: Dashboard,
    withSidebar: true,
    pageTitle: "Dashboard",
    requireLogin: true,
  },
  UPDATE_PROFILE: {
    path: "/update-profile",
    component: UserProfileUpdate,
    withSidebar: true,
    pageTitle: "Dashboard",
    requireLogin: true,
  },
  FORGOT_PASSWORD: {
    path: "/forgot-password",
    component: ForgotPassword,
    withSidebar: false,
    pageTitle: "Forgot Password",
    requireLogin: false,
    allowAccessWhenLoggedIn: false,
  },
  RESET_PASSWORD: {
    path: "/auth/reset-password",
    component: ResetPassword,
    withSidebar: false,
    pageTitle: "Reset Password",
    requireLogin: false,
    allowAccessWhenLoggedIn: false,
  },
  CREATE_PASSWORD: {
    path: "/auth/create-password",
    component: CreatePassword,
    withSidebar: false,
    pageTitle: "Create Password",
    requireLogin: false,
    allowAccessWhenLoggedIn: false,
  },
  USERS: {
    path: "/users",
    component: AdminList,
    withSidebar: true,
    pageTitle: "Users",
    requireLogin: true,
  },
  ADD_USER: {
    path: "/add-user",
    component: AddUser,
    withSidebar: true,
    pageTitle: "Add User",
    requireLogin: true,
  },
  EDIT_USER: {
    path: "/edit-user/:id",
    component: AddUser,
    withSidebar: true,
    pageTitle: "Edit User",
    requireLogin: true,
  },
  CMSPAGE: {
    path: "/cms-pages",
    component: CMSlist,
    withSidebar: true,
    pageTitle: "CMS Pages",
  },
  BLOGS: {
    path: "/blogs",
    component: Blog,
    withSidebar: true,
    pageTitle: "Blogs",
    requireLogin: true,
  },
  ADDBLOG: {
    path: "/add-blog",
    component: AddBlog,
    withSidebar: true,
    pageTitle: "Add Blog",
    requireLogin: true,
  },
  EDITBLOG: {
    path: "/edit-blog/:id",
    component: AddBlog,
    withSidebar: true,
    pageTitle: "Edit Blog",
    requireLogin: true,
  },
  // Role Management Routes
  ROLES: {
    path: "/roles",
    component: RoleList,
    withSidebar: true,
    pageTitle: "Roles",
    requireLogin: true,
  },
  ADD_ROLE: {
    path: "/add-role",
    component: AddRole,
    withSidebar: true,
    pageTitle: "Add Role",
    requireLogin: true,
  },
  EDIT_ROLE: {
    path: "/edit-role/:id",
    component: AddRole,
    withSidebar: true,
    pageTitle: "Edit Role",
    requireLogin: true,
  },
  // Activity Logs Routes
  ACTIVITY_LOGS: {
    path: "/activity-logs",
    component: ActivityLogs,
    withSidebar: true,
    pageTitle: "Activity Logs",
    requireLogin: true,
  },
};
export default routes;
